import {API_URLS} from '@/const';
import {http} from '@/helper';

export const assetsApi = {
  // overview
  transferMargin(query) {
    return http.put(API_URLS.MARGIN, {query});
  },
  indexQuote(query) {
    return http.get(API_URLS.INDEX_QUOTE, {query});
  },
  getMarginTransferList(query) {
    return http.get(API_URLS.COPY_TRADE_ACCOUNT_TRANSFER, {query});
  },
  // deposit
  getDepositList(query) {
    return http.get(API_URLS.DEPOSIT_LIST, {query});
  },
  getDepositAddress(query) {
    return http.get(API_URLS.DEPOSIT_ADDRESS, {query});
  },
  getDepositAddressInSign(query) {
    return http.get(API_URLS.DEPOSIT_ADDRESS_V3, {query});
  },
  // validate-address
  addressExist(query) {
    return http.get(API_URLS.ADDRESS_EXIST, {query});
  },
  // withdrawal
  withdrawList(query) {
    return http.get(API_URLS.WITHDRAW_LIST, {query});
  },
  withdrawFeeInfo(query) {
    return http.get(API_URLS.WITHDRAW_FEE_INFO_V2, {query});
  },
  getWithdrawKycLimit() {
    return http.get(API_URLS.WITHDRAW_KYC_LIMIT, {});
  },
  cancelWithdraw(params) {
    return http.post(API_URLS.CANCEL_WITHDRAW, {params});
  },
  withdrawAddresslist(query) {
    return http.get(API_URLS.WITHDRAW_ADDRESSLIST, {query});
  },
  createWithdraw(params) {
    return http.post(API_URLS.CREATE_WITHDRAW, {params});
  },
  createWithdrawaddress(query, params) {
    return http.post(API_URLS.CREATE_WITHDRAWADDRESS, {query, params});
  },
  deleteWithdrawaddress(params) {
    return http.delete(API_URLS.DELETE_WITHDRAWADDRESS, {params});
  },
  withdrawConfirm(query) {
    return http.get(API_URLS.WITHDRAWAL_CONFIRM, {query});
  },
  validateAddress(params) {
    return http.post(API_URLS.VALIDATE_ADDRESS, {params});
  },
  // fund-details
  getWalletsDetail(query) {
    return http.get(API_URLS.WALLET_DETAIL, {
      query,
      formatter(data) {
        const {total, rows} = data;
        rows.forEach((row) => {
          row.currency = row.currencyCode;
          delete row.currencyCode;
        });
        return {total, rows};
      },
    });
  },
  tradeAccountDetailV2(query) {
    return http.get(API_URLS.TRADE_ACCOUNT_DETAIL_V2, {query});
  },
  // pnl-details
  pnlPosition(query) {
    return http.get(API_URLS.PNL_POSITION, {query});
  },
  pnlPositionV2(query) {
    return http.get(API_URLS.PNL_POSITION_V2, {query});
  },
  pnlAccount(query) {
    return http.get(API_URLS.PNL_ACCOUNT, {query});
  },
  pnlAccountV2(query) {
    return http.get(API_URLS.PNL_ACCOUNT_V2, {query});
  },
  closedPositionList(query) {
    return http.get(API_URLS.CLOSED_POSITIONS, {query});
  },
  closedPositionListV2(query) {
    return http.get(API_URLS.CLOSED_POSITIONS_V2, {query});
  },
  exchangeFeeList(query) {
    return http.get(API_URLS.EXCHANGE_FEE_LIST, {query});
  },
  exchangeFeeListV2(query) {
    return http.get(API_URLS.EXCHANGE_FEE_LIST_V2, {query});
  },
  fundingFeeList(query) {
    return http.get(API_URLS.FUNDING_FEE_LIST, {query});
  },
  fundingFeeListV2(query) {
    return http.get(API_URLS.FUNDING_FEE_LIST_V2, {query});
  },
  // order-history
  orderList(query) {
    return http.get(API_URLS.ORDER_LIST, {query});
  },
  // order-history
  orderListV2(query) {
    return http.get(API_URLS.ORDER_LIST_V2, {query});
  },
  // trade-history
  tradeList(query) {
    return http.get(API_URLS.TRADE_LIST, {query});
  },
  tradeListV2(query) {
    return http.get(API_URLS.TRADE_LIST_V2, {query});
  },

  // spot-order-history
  spotOrderList(query) {
    return http.get(API_URLS.SPOT_ORDER_LIST, {
      query,
      formatter(data) {
        const {total} = data;
        const rows = data.rows.map((o) => ({...o, cumBaseQtyEv: o.cumBaseValueEv, cumQuoteQtyEv: o.cumQuoteValueEv}));
        return {total, rows};
      },
    });
  },
  // spot-trade-history
  spotTradeList(query) {
    return http.get(API_URLS.SPOT_TRADE_LIST, {query});
  },
  // spot-pnl-history
  spotPnlData(query) {
    return http.get(API_URLS.SPOT_PNL_DATA, {query});
  },
  spotCurrentPnl(query) {
    return http.get(API_URLS.SPOT_CURRENT_PNL, {query});
  },
  getChainSetting(query) {
    return http.get(API_URLS.CHAIN_SETTINGS, {query});
  },
  // 资产曲线
  getAssetsGraph(query) {
    return http.get(API_URLS.ASSETS_GRAPH, {query});
  },
  getConversionSupportedCurrencies(query) {
    return http.get(API_URLS.CONVERSION_SUPPORTED_CURRENCIES, {query});
  },
  getConversionQuote(query) {
    return http.get(API_URLS.CONVERSION_QUOTE, {query});
  },
  conversion(params) {
    return http.post(API_URLS.CONVERSION, {params});
  },
  transfer(params) {
    return http.post(API_URLS.TRANSFER, {params});
  },
  transferV2(query) {
    return http.get(API_URLS.COPY_TRADE_ACCOUNT_TRANSFER, {query});
  },
  getConversionsList(query) {
    return http.get(API_URLS.CONVERSIONS_LIST, {query});
  },
  postEarlyRedemption(params) {
    return http.post(API_URLS.EARLY_REDEMPTION, {params});
  },
  getAPYRate(query) {
    return http.get(API_URLS.EARLY_REDEMPTION_APY_RATE, {query});
  },
  getAssetsAcount(query) {
    return http.get(API_URLS.ASSETS_ACCOUNT, {query});
  },
  getDepositSortCurrencies() {
    return http.get(API_URLS.DEPOSIT_SORT_LIST, {});
  },
  getSuccessWithdrawOrder() {
    return http.get(API_URLS.SUCCESS_WITHDRAW_ORDER, {});
  },
  getSuccessDepositOrder() {
    return http.get(API_URLS.SUCCESS_DEPOSIT_ORDER, {});
  },
  getDepositsCheckToContract(query) {
    return http.get(API_URLS.DEPOSITS_CHECK_TO_CONTRACT, {query});
  },
  updateDepositsAccount(params) {
    return http.post(API_URLS.DEPOSITS_ACCOUNT_UPDATE, {params});
  },
  getAssetsAnnouncement(query) {
    return http.get(API_URLS.ASSETS_ANNOUNCEMENT, {query});
  },
  getWithdrawP2PFrozen(query) {
    return http.get(API_URLS.WITHDRAW_P2P_FROZEN, {query});
  },
  getWithdrawAssetFrozenTotal(query) {
    return http.get(API_URLS.WITHDRAW_ASSET_FROZEN_TOTAL, {query});
  },
  getWithdrawSortCurrencies() {
    return http.get(API_URLS.WITHDRAW_SORT_LIST, {});
  },
  getSpotEquityAssetHistory(query) {
    return http.get(API_URLS.SPOT_EQUITY_ASSET_HISTORY, {query});
  },
  getSpotEquityAssetHistoryUta(query) {
    return http.get(API_URLS.SPOT_EQUITY_ASSET_HISTORY_UTA, {query});
  },
  getAddressDomainConvert(params) {
    return http.post(API_URLS.ADDRESS_DOMAIN_CONVERT, {params});
  },
  postConvertUta(params) {
    return http.post(API_URLS.CONVERT_UTA, {params});
  },
  postWithdrawKycLimitCheck(query) {
    return http.get(API_URLS.WITHDRAW_KYC_LIMIT_CHECK_V2, {query});
  },
  validateEmailAddress(query) {
    return http.get(API_URLS.WITHDRAW_INTERNAL_ADDRESS_VALIDATE, {query});
  },
  getEmailList(query) {
    return http.get(API_URLS.WITHDRAW_INTERNAL_ADDRESS, {query});
  },
  addEmailList(query, params) {
    return http.post(API_URLS.WITHDRAW_INTERNAL_ADDRESS_V2, {query, params});
  },
  deleteEmailList(params) {
    return http.delete(API_URLS.WITHDRAW_INTERNAL_ADDRESS_DELETE, {params});
  },
  createAddress(params) {
    return http.post(API_URLS.WITHDRAW_INTERNAL_ADDRESS_CREATE, {params});
  },
  getEmailWithdrawList(query) {
    return http.get(API_URLS.WITHDRAW_INTERNAL_ADDRESS_WITHDRAW_LIST, {query});
  },
  getEmailWithdrawMin(query) {
    return http.get(API_URLS.WITHDRAW_INTERNAL_ADDRESS_INSIDE_PROP, {query});
  },
  getSupportedCcy(query) {
    return http.get(API_URLS.CONVERSION_SUPPORTED_CCY, {query});
  },
  getTinyConversionQuote(query) {
    return http.get(API_URLS.TINY_CONVERSION_QUOTE, {query});
  },
  conversionWallet(params) {
    return http.post(API_URLS.TINY_CONVERSION, {params});
  },
  getTinyConversion(query) {
    return http.get(API_URLS.TINY_CONVERSION, {query});
  },
  getConversionDetail(query) {
    return http.get(API_URLS.TINY_CONVERSION_DETAIL, {query});
  },
  getDataAssetsOverview(query) {
    return http.get(API_URLS.DATA_ASSETS_OVERVIEW, {query});
  },
  withdrawMailCode(params) {
    return http.post(API_URLS.WITHDRAW_MAIL_CODE, {params});
  },
  createNewWithdraw(params) {
    return http.post(API_URLS.WALLETS_APP_V4_CREATEWITHDRAW, {params});
  },
  createNewWithdrawV5(params) {
    return http.post(API_URLS.WALLETS_APP_V5_CREATEWITHDRAW, {params});
  },
  createNewWithdrawaddress(params) {
    return http.post(API_URLS.WALLETS_INSIDE_V2_CREATE, {params});
  },
  createNewWithdrawaddressV3(params) {
    return http.post(API_URLS.WALLETS_INSIDE_V3_CREATE, {params});
  },
  onchainWithdrawMailCode(params) {
    return http.post(API_URLS.WITHDRAW_MAIL_CODE_ONCHAIN, {params});
  },
  internalWithdrawMailCode(params) {
    return http.post(API_URLS.WITHDRAW_MAIL_CODE_INTERNAL, {params});
  },
  accountWithdrawCfg() {
    return http.get(API_URLS.WITHDRAW_ACCOUNT_CFG, {});
  },
};
